import Privileges from "./Privileges";

const userRoles = {
  admin: {
    name: "admin",
    appRole: "operator",
    privileges: {
      [Privileges.postToMlog]: true,
    },
    toFilter: [],
    filterInertMessages: false,
    showPotentialLossItems: true,
    removePreferences: [],
  },

  client: {
    name: "client",
    appRole: "operator",
    privileges: {
      [Privileges.postToMlog]: true,
    },
    toFilter: [],
    filterInertMessages: false,
    showPotentialLossItems: true,
    removePreferences: [],
  },

  demo: {
    name: "demo",
    appRole: "viewer",
    privileges: {},
    toFilter: [],
    filterInertMessages: false,
    showPotentialLossItems: false,
    removePreferences: ["potentialGraphExpandedByDefault"],
  },

  whitelabel: {
    name: "whitelabel",
    appRole: "viewer",
    privileges: {},
    toFilter: [
      // TODO: should be returned after a more granulated filter is enabled
      "f-vgridshift",
      // 'if-inv-n',
      // 'if-invdeg-n',
      // 'ef-message',
    ],
    filterInertMessages: true,
    showPotentialLossItems: false,
    removePreferences: ["potentialGraphExpandedByDefault"],
  },

  viewer: {
    name: "viewer",
    appRole: "viewer",
    privileges: {},
    toFilter: [
      // TODO: should be returned after a more granulated filter is enabled
      "f-vgridshift",
      // 'if-inv-n',
      // 'if-invdeg-n',
      // 'ef-message',
    ],
    filterInertMessages: true,
    showPotentialLossItems: false,
    removePreferences: ["potentialGraphExpandedByDefault"],
  },

  disabled: {
    name: "disabled",
    appRole: "viewer",
    privileges: {},
    toFilter: ["*"], // wildcard, means filter everything
    filterInertMessages: true,
    showPotentialLossItems: false,
    removePreferences: ["potentialGraphExpandedByDefault"],
  },
};

export default userRoles;
